module.exports = __webpack_public_path__ + "static/media/facebook.42d55551.svg";